import gsap from 'gsap'

import Deferred from '@/webgl/core/Deferred'
import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'
import SmokeRenderer from '@/webgl/runner/rendering/SmokeRenderer'

type SmokeRevealOptions = {
  delay: number
  reverse: boolean
  duration: number
}

export default class SmokeRevealAnimation implements IAnimationTrack {
  srcX: number
  srcZ: number
  options: SmokeRevealOptions

  public constructor(
    private smoke: SmokeRenderer,
    options: Partial<SmokeRevealOptions> = {}
  ) {
    this.options = {
      delay: 0,
      reverse: false,
      duration: 1.5,
      ...options,
    }
  }

  init(): void {
    this.srcX = this.smoke.node.x
    this.srcZ = this.smoke.node.z

    this.smoke.chunk.useReveal()

    this.smoke.chunk.Reveal = this.options.reverse ? 0.5 : 1.0
    this.smoke.node.z = this.options.reverse ? 0.0 : -2.0
  }

  play(): Promise<unknown> {
    const defer = new Deferred<void>()

    gsap.to(this.smoke.chunk, {
      Reveal: this.options.reverse ? 1.0 : 0.5,
      duration: this.options.duration,
      delay: this.options.delay,
    })

    gsap.to(this.smoke.node, {
      z: this.options.reverse ? -2.0 : 0.0,
      duration: this.options.duration,
      delay: this.options.delay,
      onComplete: defer.resolve,
    })

    return defer.promise
  }
}
